import React, { forwardRef } from "react";
import classNames from "classnames";
import IEditableProps from '../../utilities/IEditableProps';
import IStyledProps from '../../utilities/IStyledProps';
import IBuildrProps from '../../utilities/IBuildrProps';
import Picture from "../Picture";
import styled from 'styled-components';
import renderContent from "../../utilities/renderContent";
import { getImagePath } from "../../../src/utilities/path";

export interface IHeroSmallImageProps extends IStyledProps, IEditableProps, IBuildrProps {
    image: string;
    alt: string;
    imageHeading: string;
    backgroundColor: string;
    children;
}

const HeroSmallImageContainer = styled.div`
    .hero-small-container, .hero-small-picture {
        z-index: 1;
        @media (max-width: 767px) {
            width: 50%;
        }
    }
    .hero-small-container, .hero-small-heading {
        color: var(--colors-neutral-white, #FFF);
        font-family: "jubilat-variable", sans-serif;
        font-size: 0.88889rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.11111rem;
        letter-spacing: 0.02667rem;
    }
`;

const HeroSmallImage = forwardRef(({ cmsId, editorClassObj, image, alt, className = "", imageHeading = '', backgroundColor = '', children }: IHeroSmallImageProps, ref: any) => {
    return (
        <HeroSmallImageContainer ref={ref} data-id={cmsId} className={classNames(className, editorClassObj, "position-relative d-flex flex-md-column p-0 m-0")}>
            <div className={classNames("position-absolute w-100 h-100 d-block d-lg-none", backgroundColor)}></div>
            <div className="hero-small-container mt-auto">
                <div className="m-4">
                    <h6 className="hero-small-heading mb-0">
                        {renderContent("HeroSmallImage", imageHeading)}
                    </h6>
                    <div className="hero-small-content">
                        {children}
                    </div>
                </div>
            </div>
            <Picture src={getImagePath(image)} alt={alt} pictureClassName="hero-small-picture" className="w-100 object-fit-cover" />
        </HeroSmallImageContainer>
    );
});

export default HeroSmallImage;